import { graphql } from '../../../gql';

export const GET_CIRCLES = graphql(`
  query getCircles {
    circles {
      ...CircleFields
    }
  }
`);
